import axios from 'axios';
import { SetDocumentGridColumnsBody } from 'models/request';
import { TableColumn, Template } from 'models/response';
import { trackPromise } from 'react-promise-tracker';
import { GRIDCOLUMNSERVICE } from 'utils/constants';

/**
 * This API return the columns config for documents
 * @param {number} idProgram
 * @return {Promise<AxiosResponse<Template[]>>}
 */
const getTemplates = (idProgram: number) =>
  trackPromise(axios.get<Template[]>(`${GRIDCOLUMNSERVICE}/getProgramViews`, { params: { idProgram } }), 'module');

/**
 * This API return the columns config for documents
 * @param {number} idUser
 * @param {number} idProgram
 * @param {number} idTemplate
 * @return {Promise<AxiosResponse<TableColumn>>}
 */
const getDocumentGridColumns = (idUser: number, idProgram: number, idTemplate: number) =>
  trackPromise(
    axios.post<TableColumn>(`${GRIDCOLUMNSERVICE}/getDocumentGridColumns`, { idUser, idProgram, idTemplate }),
    'module',
  );

/**
 * This API save the columns config
 * @param {object} body
 * @param {number} body.idUser
 * @param {array} body.documentGridColumns
 * @return {Promise<AxiosResponse<TableColumn>>}
 */
const setDocumentGridColumns = (body: SetDocumentGridColumnsBody) =>
trackPromise(axios.post<TableColumn>(`${GRIDCOLUMNSERVICE}/setDocumentGridColumns`, { ...body }), 'module');

export default {
  getDocumentGridColumns,
  setDocumentGridColumns,
  getTemplates,
};
